import { Link, Text } from '@goodfynd/ui';

import { styled } from '../../../theme/stitches.config';

export const StyledContainer = styled('section', {
  padding: '80px 150px',
  '@mdMax': {
    padding: '40px 16px',
  },
});

export const StyledDescription = styled(Text, {
  marginTop: 12,
  '@xs': {
    marginTop: 8,
  },
});

export const StyledItem = styled(Link, {
  marginTop: 32,
  paddingRight: 24,
});
